"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SharedPremiumImageBanner;
const react_1 = __importDefault(require("react"));
const dispatchAnalytics_1 = require("../../utils/dispatchAnalytics");
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/button/Button");
const SharedPremiumImageBanner_module_scss_1 = __importDefault(require("./SharedPremiumImageBanner.module.scss"));
const buildImageUrl_1 = require("../../utils/buildImageUrl");
const constants_1 = require("../../constants");
function SharedPremiumImageBanner({ title, description, textColour, ctaLink, ctaText, clickUrl, accessibilityText, desktopImage, impressionUrl, associatedAdvertId, logoImage, logoAccessibilityText, logo2Image, logo2AccessibilityText, gradient, previewerSize, testId = "shared-premium", }) {
    const smSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        wid: "599",
        sm: "aspect",
        aspect: "4:5",
    });
    const mdSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        wid: "1279",
        sm: "aspect",
        aspect: "3:1",
    });
    const lgSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        wid: "1439",
        sm: "aspect",
        aspect: "4:1",
    });
    const xlSrc = (0, buildImageUrl_1.buildImageUrl)(desktopImage, {
        fmt: "auto",
        wid: "1920",
        sm: "aspect",
        aspect: "4:1",
    });
    const textColourClass = textColour === "Light" ? SharedPremiumImageBanner_module_scss_1.default.light : "";
    const underlinedButtonVariant = textColour === "Light" ? "inverted" : "default";
    const gradientClass = gradient === "Dark"
        ? previewerSize === "mobile"
            ? SharedPremiumImageBanner_module_scss_1.default["preview-gradientDark-mobile"]
            : SharedPremiumImageBanner_module_scss_1.default.gradientDark
        : gradient === "Light"
            ? previewerSize === "mobile"
                ? SharedPremiumImageBanner_module_scss_1.default["preview-gradientLight-mobile"]
                : SharedPremiumImageBanner_module_scss_1.default.gradientLight
            : null;
    // Preview sizes: mobile uses sm (0-599px), tablet uses md (600-1279px),
    // desktop uses xl (1440-1920px). The lg breakpoint (1280-1439px) is only used
    // in production responsive images but not in preview mode.
    const previewerImageSrc = previewerSize === "mobile"
        ? smSrc
        : previewerSize === "tablet"
            ? mdSrc
            : xlSrc;
    const imageContainerClassName = previewerSize
        ? SharedPremiumImageBanner_module_scss_1.default[`preview-imageContainer-${previewerSize}`]
        : SharedPremiumImageBanner_module_scss_1.default.imageContainer;
    const contentContainerClassName = previewerSize
        ? SharedPremiumImageBanner_module_scss_1.default[`preview-contentContainer-${previewerSize}`]
        : SharedPremiumImageBanner_module_scss_1.default.contentContainer;
    const hasDescription = Boolean(description === null || description === void 0 ? void 0 : description.slice(0, constants_1.PREMIUM_IMAGE_BANNER_CHAR_LIMIT));
    const titleClassName = previewerSize
        ? [
            SharedPremiumImageBanner_module_scss_1.default[`preview-title-${previewerSize}`],
            !hasDescription &&
                SharedPremiumImageBanner_module_scss_1.default[`preview-title-${previewerSize}-noDescription`],
        ]
            .filter(Boolean)
            .join(" ")
        : [SharedPremiumImageBanner_module_scss_1.default.title, !hasDescription && SharedPremiumImageBanner_module_scss_1.default["title-noDescription"]]
            .filter(Boolean)
            .join(" ");
    const descriptionClassName = previewerSize
        ? SharedPremiumImageBanner_module_scss_1.default[`preview-description-${previewerSize}`]
        : SharedPremiumImageBanner_module_scss_1.default.description;
    const smallCtaContainerClassName = previewerSize
        ? SharedPremiumImageBanner_module_scss_1.default[`preview-smallCtaContainer-${previewerSize}`]
        : SharedPremiumImageBanner_module_scss_1.default.smallCtaContainer;
    const largeCtaContainerClassName = previewerSize
        ? SharedPremiumImageBanner_module_scss_1.default[`preview-largeCtaContainer-${previewerSize}`]
        : SharedPremiumImageBanner_module_scss_1.default.largeCtaContainer;
    const logosContainerClassName = previewerSize
        ? SharedPremiumImageBanner_module_scss_1.default[`preview-logosContainer-${previewerSize}`]
        : SharedPremiumImageBanner_module_scss_1.default.logosContainer;
    const truncatedTitle = title.slice(0, constants_1.PREMIUM_IMAGE_BANNER_CHAR_LIMIT);
    const truncatedDescription = description === null || description === void 0 ? void 0 : description.slice(0, constants_1.PREMIUM_IMAGE_BANNER_CHAR_LIMIT);
    return (react_1.default.createElement("a", { href: ctaLink, "data-testid": `${testId}-image-banner-link`, onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
            });
        }, className: SharedPremiumImageBanner_module_scss_1.default.bannerLink },
        react_1.default.createElement("div", { className: imageContainerClassName },
            previewerSize ? (react_1.default.createElement("img", { "data-testid": `${testId}-image-banner-main-image`, src: previewerImageSrc, alt: accessibilityText })) : (react_1.default.createElement("picture", null,
                react_1.default.createElement("source", { media: "(min-width: 1440px)", srcSet: xlSrc }),
                react_1.default.createElement("source", { media: "(min-width: 1280px)", srcSet: lgSrc }),
                react_1.default.createElement("source", { media: "(min-width: 600px)", srcSet: mdSrc }),
                react_1.default.createElement("img", { "data-testid": `${testId}-image-banner-main-image`, src: smSrc, alt: accessibilityText }))),
            gradientClass && react_1.default.createElement("div", { className: gradientClass, "aria-hidden": "true" }),
            react_1.default.createElement("div", { className: contentContainerClassName },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h2", { "data-testid": `${testId}-image-banner-title`, className: `${titleClassName} ${textColourClass}` }, truncatedTitle),
                    truncatedDescription && (react_1.default.createElement("p", { "data-testid": `${testId}-image-banner-description`, className: `${descriptionClassName} ${textColourClass}` }, truncatedDescription)),
                    react_1.default.createElement("div", { className: smallCtaContainerClassName },
                        react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", variant: underlinedButtonVariant, className: textColourClass, labelText: ctaText, "data-testid": `${testId}-image-banner-small-cta` })),
                    react_1.default.createElement("div", { className: largeCtaContainerClassName },
                        react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", variant: underlinedButtonVariant, className: textColourClass, labelText: ctaText, "data-testid": `${testId}-image-banner-large-cta` })))),
            react_1.default.createElement("div", { className: logosContainerClassName },
                react_1.default.createElement("img", { src: logoImage, alt: logoAccessibilityText, "data-testid": `${testId}-image-banner-logo` }),
                logo2Image ? (react_1.default.createElement("img", { alt: logo2AccessibilityText || "", src: logo2Image, "data-testid": `${testId}-image-banner-logo-2` })) : null))));
}
